<template>
    <div class="block">
        <a href="#" :class="isLoad ? 'title open':'title'" @click.prevent="getItems">Сотрудничество с вузами</a>
        <transition name="fade">
        <div class="content" style="overflow: auto;" v-if="isLoad">
            <table class="table table-bordered">
                <thead>
                <tr>
                    <th rowspan="2">Договор</th>
                    <th colspan="2">Стороны договора:</th>
                    <th rowspan="2">Направление сотрудничества</th>
                    <th rowspan="2">Количество выпускников, поступивших в указанный вуз</th>
                    <th rowspan="2">Количество обучающихся, заключивших отложенный договор с указанными работодателем из
                        числа завершивших обучение в прошлом учебном году
                    </th>
                    <th rowspan="2">Копия договора (титульная страница)</th>
                </tr>
                <tr>
                    <th>организация высшего образования</th>
                    <th>организации-партнеры из числа возможных работодателей</th>
                </tr>
                </thead>
                <tbody v-if="items">
                    <tr v-bind:key="item.id" v-for="item in items">
                        <td>{{item.contract}}</td>
                        <td>{{item.organization}}</td>
                        <td>{{item.partners}}</td>
                        <td>{{item.direction}}</td>
                        <td>{{item.numberGraduated}}</td>
                        <td>{{item.numberStudents}}</td>
                        <td>
                            <a target="_blank" :href="item.copyContract" v-if="item.copyContract">Файл</a>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="7">Загрузка данных...</td>
                    </tr>
                </tbody>
            </table>
        </div>
        </transition>
    </div>
</template>

<script>
    import Axios from 'axios'
    import _ from 'lodash'

    export default {
        name: "Cooperation",


        data() {
            return {
                items: false,
                isLoad: false,
            }
        },

        methods: {
            getItems() {
                if(!this.isLoad && !this.items){
                    this.isLoad = true
                    const path = this.$store.state.api + this.$store.state.apiCooperation + "?eoId=" + this.$store.state.eoId
                    const $this = this
                    Axios({
                        method: 'get',
                        url: path
                    }).then((response) => {
                        if (
                            response.status == 200
                            && response.data.result == "success"
                        ) {
                            $this.items = _.filter(response.data.data, function (o) {
                                return  (
                                    (typeof(o.projectType.altName) !== 'undefined')
                                    && (o.projectType.altName == $this.$store.state.type)
                                )
                            });
                        }
                    })
                }else{
                    this.isLoad = !this.isLoad
                }
            }
        },
    }
</script>

<style scoped>

</style>
